var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.notEmpty)?_c('div',{staticClass:"icon-counter",class:_vm.variant},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.count))]})],2):_vm._e(),_c('icon',_vm._b({attrs:{"name":_vm.name}},'icon',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }